import { Dialog } from "@mui/material";
import materialUI from "material-UI";
import { COLORS } from "screens/perfilAutonomo/utils";
import styled from "styled-components";
import colors from "../../../../constants/color";

export const DialogContainer = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 12px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 85vh;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  font-family: Inter;
  gap: 12px;

  .title {
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.gray500};
    text-align: flex-start;
    width: 100%;
    margin-left: 10px;
  }
  .center {
    align-self: center;
  }
  .subtitle {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${COLORS.gray300};
  }
  .error-text {
    margin-top: 5px;
    font-size: 12px;
    color: red;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
  gap: 10px;

  .icon-wrapper {
    background-color: #d1fadf;
    border-radius: 50%;
    border: 8px solid #ecfdf3;
    padding: 8px;
    font-size: 20px;
  }
  .exit {
    color: #667085;
    :hover {
      cursor: pointer;
    }
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  label {
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS.gray400};
    margin: 8px 0px;
  }
  .radio {
    display: flex;
    flex-direction: row;
    width: 100%;
    justify-content: flex-start;
    align-items: center;

    p {
      font-size: 14px;
      font-weight: 400;
      color: ${COLORS.gray500};
    }
  }
  .error-text {
    font-size: 12px;
    color: red;
  }
  .field-name {
    font-size: 14px;
    font-weight: 500;
    color: ${COLORS.gray400};
    padding-bottom: 8px;

    span {
      color: red;
    }
  }
  .upload {
    display: flex;
    flex-direction: column;
    gap: 12px;
    width: 100%;
  }
`;

export const Buttons = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  gap: 20px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  gap: 20px;
  overflow-y: auto;
  min-width: 800px;
`;

export const Row = styled.div<{ template?: string }>`
  display: grid;
  grid-template-columns: ${({ template }) => template ?? "1fr 1fr"};
  grid-gap: 20px;
  align-items: center;
  width: 100%;
`;

export const Section = styled.h2`
  font-size: 16px;
  color: ${COLORS.gray400};
`;

export const Block = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: calc(100% - 2px) !important;
  padding: 20px;
  box-sizing: border-box;
  gap: 10px;
  border: 1px solid #d0d5dd;
  border-radius: 8px;
`;

export const Field = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
  width: 100%;
`;

export const Convidados = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 4px;
`;

export const TimePicker = styled(materialUI.TimePicker)`
  width: 100%;
  & .MuiOutlinedInput-root.Mui-disabled,
  & .MuiInputBase-root.Mui-disabled {
    background-color: rgb(208, 213, 221);
  }
`;

export const LocalizationProvider = styled(materialUI.LocalizationProvider)`
  display: flex;
  align-items: center;
`;

export const TextField = styled(materialUI.TextField)`
  label {
    display: none;
  }
  .MuiInputBase-adornedEnd {
    min-height: 44px;
  }
  .MuiInputBase-root {
    border-radius: 8px;
    .MuiAutocomplete-input {
      padding: 2px 4px;
    }
  }
  .Mui-focused {
    fieldset {
      border-color: ${colors.primary} !important;
    }
  }
  &.input-disabled {
    background-color: ${colors.gray100};
    input {
      color: ${colors.grey1};
    }
  }
`;
